import React, { useEffect } from 'react';
import Table from '../../components/Table';
import { observer } from 'mobx-react-lite';
import Pagination from './../../components/Pagination';
import Button from '../../components/Button';
import { FaSearch } from 'react-icons/fa';
import { useHistory, useParams } from 'react-router-dom';
import { formatDate, formatTime } from '../../helpers/formatDate';

const UserChanges = ({ store }) => {
    const history = useHistory();
    const { user_id } = useParams();

    useEffect(() => {
        store.getUserChanges(undefined, user_id);
        return () => {
            store.setSearchQuery('');
        };
    }, [store, store.selectedPage, user_id]);

    const handleViewDetails = (changeId) => {
        history.push(`/fans/${user_id}/user-changes/${changeId}`);
    };

    return (
        <>
            {store.userChanges && store.userChanges.length !== 0 && (
                <Table
                    tablePagination={
                        store?.totalPages > 1 && (
                            <Pagination
                                totalPages={store?.totalPages}
                                selectedPage={store?.selectedPage}
                                onSelectedPageChange={(selected) => store?.setSelectedPage(selected)}
                            />
                        )
                    }
                    tableName="User Changes"
                    columns={[
                        {
                            Header: 'Date',
                            accessor: 'date',
                            isFixedWider: true,
                            Cell: ({ value }) => <div>{value}</div>,
                        },
                        {
                            Header: 'Changed by',
                            accessor: 'changed_by',
                            Cell: ({ value }) => <div>{value || '-'}</div>,
                        },
                        {
                            Header: 'Details',
                            accessor: 'details',
                            Cell: ({ row }) => (
                                <div className="button-cell">
                                    <Button
                                        onClick={() => handleViewDetails(row.original.id)}
                                        title="View Details"
                                    >
                                        <FaSearch />
                                    </Button>
                                </div>
                            ),
                        },
                    ]}
                    data={store.userChanges.map((change) => {
                        return {
                            id: change.id,
                            date: formatDate(change.created_at),
                            changed_by: change.email || '-',
                        };
                    })}
                />
            )}
        </>
    );
};

export default observer(UserChanges);
